import { mergePositional } from './positional';

export const mergeChoiceMatrix = (jsonData, translated) => ({
  ...jsonData,
  stimulus: translated.stimulus ?? jsonData.stimulus,
  stems: mergePositional(jsonData.stems, translated.stems),
  options: mergePositional(jsonData.options, translated.options),
});
